<template>
  <div :style="itemStyle" :class="{ 'mr-0': (index + 1) % column === 0 }">
    <slot></slot>
  </div>
</template>

<script setup>
import { computed } from "vue";
const props = defineProps({
  // 索引
  index: {
    type: Number,
    default: 0,
  },
  //列数
  column: {
    type: Number,
    default: 3,
  },
  //间隔
  gap: {
    type: Number,
    default: 12,
  },
});
const itemStyle = computed(() => {
  const gaps = (props.column - 1) * props.gap;
  const columnWidth = `calc((100% - ${gaps}px) / ${props.column})`;
  return {
    width: columnWidth,
    "margin-bottom": `${props.gap}px`,
    "margin-right": `${props.gap}px`,
  };
});
</script>

<style lang="scss" scoped>
.mr-0 {
  margin-right: 0 !important;
}
</style>